module.exports = __webpack_public_path__ + "static/img/invest-make3.771b57c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-make3.jpg
// module id = TETY
// module chunks = 0